import React, { Component, createRef } from 'react';
import Axios from 'axios';
import { 
	DURATION_TYPE,
	INFORMED_BY,
	MEDICATION_ON,
	FETAL_MOVEMENT,
	PRESENTATION,
	RELATIONSHIP_TO_PP_BRIM,
	CONCEPTION_OPTIONS,
    PREGNANCY_OPTIONS,
    DELIVERY_OPTIONS,
    OUTCOME_OPTIONS,
    PLACE_OF_DELIVERY_OPTIONS,
    LOADER,
    Print_Anc_Details
 } from "../../utils/constant";
import moment from "moment";
import { DatePicker, Radio, Modal, Select, Button, Form, Checkbox, Input, Tooltip, AutoComplete, notification } from 'antd';
import AsideLeft from '../../components/aside/asideleft';
import LS_SERVICE from "../../utils/localStorage";

export default class AncCardView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            patientInfo: props.patientInfo || [],
            risk_factors_options: props.riskFactorsOptions || [],
            indexKey: props.index,
            AncCardData : props.AncCardData,
            gender_options: [
                { val: '1', label: 'Male' },
                { val: '2', label: 'Female' },
                { val: '3', label: 'Transgender' }
            ],
            showRxModal: false,
    		rxPdfPath: null,
    		isPrintLoader: false,
        }
    }

    getPatientAge(dob) {
        var ageD = Math.floor(moment().diff(moment(dob, 'YYYY-MM-DD'), 'D') / (1000 * 3600 * 24));
        var ageM = moment().diff(moment(dob, 'YYYY-MM-DD'), 'M');
        var ageY = ageM / 12;
        var remainM = ageM % 12;
        ageY = Math.floor(ageY);
        var ageText = '';
        if (ageM == 0)
            ageText = ageD + ' Day' + (ageD == 1 ? '' : 's');
        else if (ageY < 1)
            ageText = ageM + ' Mon' + (ageM == 1 ? '' : 's');
        else if (ageY <= 5) {
            if (remainM != 0) {
                ageText = ageY + ' Yr' + (ageY == 1 ? '' : 's ') + remainM + ' Mon' + (remainM == 1 ? '' : 's');
            } else {
                ageText = ageY + ' Yr' + (ageY == 1 ? '' : 's');
            }
        }
        else
        ageText = ageY + ' Years' + (remainM != 0 ? ' ' + remainM + ' Month' + (remainM === 1 ? '' : 's') : '');
        return ageText;
    }

    getListValue(selectedValue, OptionObj = null) {
        if (selectedValue == 0 || selectedValue === null) {
            return "-";
        } else if (OptionObj) {
            return OptionObj[selectedValue];
        } else {
            return selectedValue;
        }
    }

    // Renders a SEPARATE table per fetus_no (same as the ANC card page): one table for
    // Fetus 1, another for Fetus 2, etc. Within each table records are shown latest first.
    showFetalParameterTables(mother_fetus_data) {
        const rows = Array.isArray(mother_fetus_data) ? mother_fetus_data : [];
        if (rows.length === 0) {
            return (
                <div className='row mt-3'>
                    <table className="table table-bordered mt-2">
                        <tbody>
                            <tr><td className="text-center">No data available</td></tr>
                        </tbody>
                    </table>
                </div>
            );
        }

        // Group rows by fetus_no (fall back to 1 when missing).
        const groups = {};
        rows.forEach((r) => {
            const key = (r.fetus_no != null && r.fetus_no !== '') ? parseInt(r.fetus_no) : 1;
            if (!groups[key]) groups[key] = [];
            groups[key].push(r);
        });

        const fetusNos = Object.keys(groups).map(k => parseInt(k)).sort((a, b) => a - b);

        return fetusNos.map((fno) => {
            // Latest saved first within this fetus.
            const fetusRows = [...groups[fno]].sort((a, b) => (b.id || 0) - (a.id || 0));
            return (
                <div className='row mt-3' key={'fetus-' + fno}>
                    <div className='col-12'>
                        <span className='title'>{'Fetus ' + fno}</span>
                    </div>
                    <table className="table table-bordered mt-2">
                        <thead>
                            <tr>
                                <td width="12%">DATE &amp; TIME</td>
                                <td width="12%">SAVED BY</td>
                                <td width="11%">FETAL MOVEMENT</td>
                                <td width="9%">FHR(B/Min)</td>
                                <td width="11%">PRESENTATION</td>
                                <td width="11%">RELATION OF PP TO BRIM</td>
                                <td width="9%">HEAD CC (CM)</td>
                                <td width="9%">ABDOMINAL CC (CM)</td>
                                <td width="9%">FEMUR LENGTH(CM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            {fetusRows.map((data, i) => (
                                <tr key={data.id || i}>
                                    <td className="text-center">{(data.updatedAt || data.createdAt) ? moment(data.updatedAt || data.createdAt).format("D MMM, YYYY | h:mm A") : '-'}</td>
                                    <td className="text-center">{data.saved_by_doctor_name || '-'}</td>
                                    <td className="text-center">{this?.getListValue(data.fetal_movement, FETAL_MOVEMENT)}</td>
                                    <td className="text-center">{data.fetal_heart_rate || '-'}</td>
                                    <td className="text-center">{this?.getListValue(data.presentation, PRESENTATION)}</td>
                                    <td className="text-center">{this?.getListValue(data.relationship_of_pp_to_brim, RELATIONSHIP_TO_PP_BRIM)}</td>
                                    <td className="text-center">{data.head_cc || '-'}</td>
                                    <td className="text-center">{data.abdominal_cc || '-'}</td>
                                    <td className="text-center">{data.femur_length || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        });
    }

    printAncDetails = async () => {
    	const { AncCardData } = this.state;
	    const BODY = {
	    	patient_id: parseInt(AncCardData.patient_id),
			hospital_id: parseInt(AncCardData.hospital_id),
			enterprise_id: parseInt(AncCardData.enterprise_id),
			anc_id: parseInt(AncCardData.id),
			printed_by : parseInt(LS_SERVICE.get('staff_id')),
	    }
	    await this.setState({ isPrintLoader : true });
	    await Axios.post(Print_Anc_Details, BODY).then(async (response) => {
			if(response.data.status == true)
			{
				await this.setState({ rxPdfPath: response.data.pdf_url, showRxModal: true, });

			} else {
				notification.error({
	                message: "Oops! Something snapped. Please try again.",
	                placement: "topRight",
	            });
			}
	    	await this.setState({ isPrintLoader : false });
	    }).catch(async (err) => {
			notification.error({
                message: "Oops! Something snapped. Please try again.",
                placement: "topRight",
            });
            await this.setState({ isPrintLoader : false });
	    });
    
  	}

    // Maps the stored caesarean-section type value to a display label (capitalised).
    getCaesareanLabel(value) {
        if (!value) return '';
        const v = String(value).toLowerCase();
        if (v === 'emergency') return 'Emergency';
        if (v === 'elective') return 'Elective';
        // Fallback: show the raw value capitalised.
        return v.charAt(0).toUpperCase() + v.slice(1);
    }

    showMultiplePregnancyData(multiple_pregnancies) {
    	if (multiple_pregnancies.length == 0) {
            return (
                <tr>
                    <td colSpan="8">No data available</td>
                </tr>
            );
        }
        // Delivery Type, Delivery Place and Outcome are common to the whole delivery and are
        // shown once above the table (after Pregnancy Type), so they are no longer repeated per
        // fetus row here. Caesarean type (for LSCS) is shown with the common Delivery Type.
        return multiple_pregnancies.map((data, i) => (
            <tr key={data.id} className={i != 0 ? 'highlight_bg' : ''}>
                <td className="text-center" style={(i + 1) == multiple_pregnancies.length && (i + 1) == multiple_pregnancies.length ? { paddingBottom: '20px' } : {}}>{i + 1}</td>
                <td className="text-center">{this.state.gender_options?.filter(x => x.val == data.delivery_gender)?.[0]?.label}</td>
                <td className="text-center">{ data?.delivery_bith_date_time != null ? moment(data?.delivery_bith_date_time, 'YYYY-MM-DD HH:mm:ss').format("DD MMM, YYYY | hh:mm A") : 'N/A'}</td>
                <td className="text-center">{data.delivery_birth_weight}</td>
                <td className="text-center">{data.delivery_birth_height}</td>
                <td className="text-center">{data.delivery_birth_head_cc}</td>
                <td className="text-center">{data?.delivery_congenital_abnormality == "true" ? "Yes" : "No"}</td>
                <td className="text-center">{data.delivery_congenital_abnormality_remarks}</td>
            </tr>
        ));
    }

    render() {
        const { patientInfo, risk_factors_options } = this.state;
        // For previous (closed) ANC cards, the pregnancy data is stored inside the single
        // obs_gyane_data JSON column (not as separate top-level fields). Normalize it so the
        // Menstrual / Obstetric / Mother Parameter / Fetal Parameter sections below can read
        // the same field names they use for the active card.
        const rawAncCardData = this.state.AncCardData || {};
        const obsGyane = rawAncCardData.obs_gyane_data && typeof rawAncCardData.obs_gyane_data === 'object'
            ? rawAncCardData.obs_gyane_data
            : {};
        // Closing a pregnancy stores the delivery/birth date on each fetus row as
        // multiple_pregnancies[].delivery_bith_date_time; the previous-card header
        // historically read a non-existent top-level delivery_date and stayed blank.
        // Use the first fetus carrying a date, while retaining top-level fallbacks for
        // older ANC records.
        const deliveryFetus = Array.isArray(rawAncCardData.multiple_pregnancies)
            ? rawAncCardData.multiple_pregnancies.find((fetus) => (
                fetus?.delivery_bith_date_time || fetus?.birth_date_time
            ))
            : null;
        const previousDeliveryDate = rawAncCardData.delivery_date
            || rawAncCardData.delivery_bith_date_time
            || deliveryFetus?.delivery_bith_date_time
            || deliveryFetus?.birth_date_time
            || null;
        const AncCardData = {
            ...rawAncCardData,
            delivery_date: previousDeliveryDate,
            menstural_data: rawAncCardData.menstural_data || obsGyane.menstural_data || null,
            obstetric_data: rawAncCardData.obstetric_data || obsGyane.obstetric_data || null,
            mother_parameter_data: rawAncCardData.mother_parameter_data || obsGyane.mother_parameter_data || null,
            mother_parameter_data_all: rawAncCardData.mother_parameter_data_all || obsGyane.mother_parameter_data_all || null,
            mother_fetus_data: (rawAncCardData.mother_fetus_data && rawAncCardData.mother_fetus_data.length > 0)
                ? rawAncCardData.mother_fetus_data
                : (obsGyane.mother_fetus_data || []),
        };
        return (
            <>
                <div className='mt-2 anc_accordion' id={"accordion" + this.state.indexKey}>
                    <div className="card">
                        <div className="card-header" id={"headingOne" + this.state.indexKey}>
                            <button className="btn btn-block text-left  collapsed arrow float-right anc_button mb-0" data-toggle="collapse" data-target={"#collapseOne" + this.state.indexKey} aria-expanded="true" aria-controls={"collapseOne" + this.state.indexKey}>
                                <div className='row'>
                                    <div className='col-3'>
                                        <span className='title'>ANC Card Details</span>
                                    </div>
                                    <div className='col-4'>
                                        <span className='title'>Delivery Date :&nbsp;</span>
                                        <span className='title'>{AncCardData.delivery_date != null ? moment(AncCardData.delivery_date).format("D MMM, YYYY") : null}</span>
                                    </div>
                                    <div className='col-4'>
                                        <span className='title'>Last Update :&nbsp;</span>
                                        <span className='title'>{AncCardData.updatedAt ? moment(AncCardData.updatedAt).format("D MMM, YYYY ") : null}</span>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div id={"collapseOne" + this.state.indexKey} className="collapse " aria-labelledby={"headingOne" + this.state.indexKey} data-parent={"#accordion" + this.state.indexKey}>
                            <div className="card-body px-0"></div>

                            {/* Cap the expanded card height and scroll its content vertically so a long
                                previous ANC card doesn't stretch the whole page. */}
                            <div className="container-fluid emrfrm anc-container mb-4 " style={{ maxHeight: 'calc(100vh - 220px)', overflowY: 'auto' }}>
                                <Form
                                    layout="vertical"
                                    className="emrfrm"
                                >
                                	{
                                    	AncCardData?.menstural_data 
                                    	?
	                                        <>
	                                            <div className='row mt-3'>
	                                                <div className='col-12'>
	                                                    <h6 className='font-weight-bold mb-0'>Menstrual History</h6>
	                                                </div>
	                                            </div>
	                                            <div className='row mt-3'>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>LMP</div>
	                                                    <div className='font-weight-bold'>
	                                                    	{(AncCardData?.menstural_data?.lmp && AncCardData?.menstural_data.lmp != null) ? moment(AncCardData?.menstural_data.lmp).format('DD MMM, YYYY'): '-'}
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>Cycle Length</div>
	                                                    <div className='font-weight-bold'>
	                                                    	{(AncCardData?.menstural_data?.cycle_length != null && AncCardData?.menstural_data?.cycle_length != "") ? AncCardData?.menstural_data?.cycle_length + " days" : '-'}
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>GA Today</div>
	                                                    <div>
	                                                        {
	                                                            (AncCardData?.delivery_gestational_age != null && AncCardData?.delivery_gestational_age !== '')
	                                                            ?
	                                                                <span className='px-3 py-1 rounded font-weight-bold' style={{ backgroundColor: '#e8f0fe', color: '#1a73e8' }}>
	                                                                    {AncCardData?.delivery_gestational_age} (from LMP)
	                                                                </span>
	                                                            :
	                                                                <span className='font-weight-bold'>-</span>
	                                                        }
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>Last Updated</div>
	                                                    <div className='font-weight-bold'>
	                                                        {AncCardData?.menstural_data?.updatedAt ? moment(AncCardData?.menstural_data?.updatedAt).format("D MMM, YYYY | h:mm A") : '-'}
	                                                    </div>
	                                                </div>
	                                            </div>
	                                        </>
                                        : 
                                        null
                                    }
                                    {
                                    	AncCardData ?
                                        <>
                                            <div className='row mt-3'>
                                                <div className='col-12'>
                                                    <h6 className='font-weight-bold mb-0'>Obstetric History</h6>
                                                </div>
                                            </div>
                                            <div className='row mt-3'>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>EDD by LMP</div>
                                                    <div className='font-weight-bold'>{AncCardData?.obs_gyane_data?.edd_by_lmp ? moment(AncCardData?.obs_gyane_data?.edd_by_lmp).format("D MMM, YYYY") : '-'}</div>
                                                </div>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>Corrected EDD</div>
                                                    <div>
                                                        {
                                                            (AncCardData?.obs_gyane_data?.corrected_edd != null && AncCardData?.obs_gyane_data?.corrected_edd != "")
                                                            ?
                                                                <span className='px-3 py-1 rounded font-weight-bold text-white' style={{ backgroundColor: '#c0392b' }}>
                                                                    {moment(AncCardData?.obs_gyane_data?.corrected_edd).format("D MMM, YYYY")}
                                                                </span>
                                                            :
                                                                <span className='font-weight-bold'>-</span>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>Lactating</div>
                                                    <div className='font-weight-bold'>{(AncCardData?.obs_gyane_data?.lactating && AncCardData?.obs_gyane_data?.lactating == "1") ? 'Yes' : 'No'}</div>
                                                </div>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>Gravidity / Parity</div>
                                                    <div>
                                                    {
                                                        AncCardData?.obstetric_data
                                                        ?
                                                            <span className="bg-grey py-1 px-3 rounded font-weight-bold">
                                                                {(AncCardData?.obstetric_data.gravidity != null && AncCardData?.obstetric_data.gravidity !== '') ? 'G'+AncCardData?.obstetric_data.gravidity+' ' : ''}{(AncCardData?.obstetric_data.parity != null && AncCardData?.obstetric_data.parity !== '') ? 'P'+AncCardData?.obstetric_data.parity+' ' : ''}{(AncCardData?.obstetric_data.abortion != null && AncCardData?.obstetric_data.abortion !== '') ? 'A'+AncCardData?.obstetric_data.abortion+' ' : ''}{(AncCardData?.obstetric_data.live_birth != null && AncCardData?.obstetric_data.live_birth !== '') ? 'L'+AncCardData?.obstetric_data.live_birth+' ' : ''}{(AncCardData?.obstetric_data.ectopic != null && AncCardData?.obstetric_data.ectopic !== '') ? 'E'+AncCardData?.obstetric_data.ectopic+' ' : ''}
                                                            </span>
                                                        :
                                                        <span className='font-weight-bold'>-</span>
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                            	AncCardData?.obs_gyane_data?.obstetric_remarks && AncCardData?.obs_gyane_data?.obstetric_remarks != "" && AncCardData?.obs_gyane_data?.obstetric_remarks != null 
                                            	?
		                                            <div className='row mt-3'>
		                                                <div className='col-2'>
		                                                    <span className='title'>Obstetric Remarks</span>
		                                                </div>
		                                                <div className='col-10'>
		                                                    <pre style={{ fontSize: "15px", border: "none" }}>{AncCardData?.obs_gyane_data.obstetric_remarks}</pre> 
		                                                </div>
		                                            </div>
                                            	: 
                                            	null
                                            }
                                        </>
                                        : 
                                        null
                                    }
                                	{
                                		AncCardData?.current_allergies?.length > 0 
                                		? 
                                			<>
	                                        <div className='row mt-3'>
	                                            <div className='col-12'>
	                                                <span className='title'> Allergies</span>
	                                            </div>
	                                        </div>

	                                        <table className="table table-bordered mt-3" >
	                                            <thead>
	                                                <tr>
	                                                    <td width="28%">ALLERGY NAME</td>
	                                                    <td width="22%">REACTION</td>
	                                                    <td width="15%">DURATION</td>
	                                                    <td width="15%">INTENSITY</td>
	                                                    <td width="15%">INFORMED BY</td>
	                                                </tr>
	                                            </thead>
	                                            <tbody>
	                                                {AncCardData?.current_allergies.map(obj => {
	                                                    return (
	                                                        <tr>
	                                                            <td>{(obj.allergy_name) ? obj.allergy_name : '-'}</td>
	                                                            <td>{(obj.reaction) ? obj.reaction : '-'}</td>
	                                                            <td>{obj.duration ? obj.duration + ' ' + DURATION_TYPE[obj.durationType] : '-'}</td>
	                                                            <td>{obj.intensity === 0 ? "Low" : obj.intensity === 1 ? "Medium" : obj.intensity === 2 ? "High" : ''}</td>
	                                                            <td>{obj.informedBy ? INFORMED_BY[obj.informedBy] : '-'}</td>
	                                                        </tr>
	                                                    )
	                                                })
	                                                }
	                                            </tbody>
	                                        </table>
                                    		</> 
                                		: 
                                		null
                                	}
                                	{
                                		AncCardData?.current_conditions?.length > 0 
                                		? 
                                			<>
	                                        <div className='row mt-3'>
	                                            <div className='col-12'>
	                                                <span className='title'>Existing Condition</span>
	                                            </div>
	                                        </div>

	                                        <table className="table table-bordered mt-3" >
	                                            <thead>
	                                                <tr>
	                                                    <td width="30%">CONDITIONS</td>
	                                                    <td width="20%">DURATION</td>
	                                                    <td width="20%">ON MEDICATION</td>
	                                                    <td width="30%">MEDICINE NAME</td>
	                                                </tr>
	                                            </thead>
	                                            <tbody>
	                                                {AncCardData?.current_conditions.map(obj => {
	                                                    return (
	                                                        <tr>
	                                                            <td>{obj.condition_description}</td>
	                                                            <td>{(obj.duration) ? `${obj.duration} ${DURATION_TYPE[obj.durationType]}` : '-'}</td>
	                                                            <td>{MEDICATION_ON[obj.onMedication] ? MEDICATION_ON[obj.onMedication] : '-'}</td>
	                                                            <td>{obj.medicineName || "NA"}</td>
	                                                        </tr>
	                                                    );
	                                                })
	                                                }
	                                            </tbody>
	                                        </table>
                                    		</>
                                		: 
                                		null
                                	}
                                    {
                                    	AncCardData.mother_parameter_data || (AncCardData.mother_fetus_data && AncCardData.mother_fetus_data.length > 0) 
                                    	?
	                                        <>
	                                            <div className='row mt-3'>
	                                                <div className='col-12'>
	                                                    <span className='title'> Physical Examination</span>
	                                                </div>
	                                            </div>
	                                            {
	                                            	AncCardData.mother_parameter_data ?
	                                                <>
	                                                    <div className='row mt-3 '>
	                                                        <div className='col-4'>
	                                                            <span className='title'>Mother's Parameters</span>
	                                                        </div>
	                                                        <div className='col-8 text-right'>
	                                                            <span className='title'>
	                                                            	Last Updated ({moment(AncCardData.mother_parameter_data.updatedAt).format("D MMM, YYYY | h:mm A")})
	                                                            </span>
	                                                        </div>
	                                                        <table className="table table-bordered mt-3" >
	                                                            <thead>
	                                                                <tr>
	                                                                    <td width="12%">DATE &amp; TIME</td>
	                                                                    <td width="12%">SAVED BY</td>
	                                                                    <td width="9%">POG (WEEKS)</td>
	                                                                    <td width="9%">WEIGHT (KG)</td>
	                                                                    <td width="9%">BP (MMHG)</td>
	                                                                    <td width="9%">PULSE RATE (MIN)</td>
	                                                                    <td width="9%">FUNDAL HT (CM)</td>
	                                                                    <td width="8%">EDEMA</td>
	                                                                    <td width="8%">PALLOR</td>
	                                                                    <td width="8%">CERVIX EXAM</td>
	                                                                    <td width="9%">PRETERM LABOUR (SIGN/SYMPTOMS)</td>
	                                                                </tr>
	                                                            </thead>
	                                                            <tbody>
	                                                            	<tr>
													                    <td className="text-center">{(AncCardData.mother_parameter_data.updatedAt || AncCardData.mother_parameter_data.createdAt) ? moment(AncCardData.mother_parameter_data.updatedAt || AncCardData.mother_parameter_data.createdAt).format("D MMM, YYYY | h:mm A") : '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.saved_by_doctor_name || '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.pog || '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.weight || '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.blood_pressure || '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.pulse_rate || '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.fundal_height || '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.edema || '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.pallor || '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.cervix_exam || '-'}</td>
													                    <td className="text-center">{AncCardData.mother_parameter_data.preterm_labour || '-'}</td>
													                </tr>
	                                                            </tbody>
	                                                        </table>
	                                                    </div>
	                                                </>
	                                                : 
	                                                null
	                                            }
	                                            <div className='row mt-3 '>
	                                                <div className='col-12'>
	                                                    <span className='title'>Fetal Parameters</span>
	                                                </div>
	                                            </div>
	                                            {this.showFetalParameterTables(AncCardData?.mother_fetus_data)}
	                                        </>
                                        : 
                                        null
                                    }

                                    {
                                        /* Investigations: remarks, title/description rows and any saved results (read-only). */
                                        (
                                            (AncCardData?.investigation_remarks && AncCardData?.investigation_remarks != "")
                                            || (AncCardData?.test_procedures_data?.length > 0)
                                            || (AncCardData?.anc_result_structured_data?.length > 0)
                                        )
                                        ?
                                            <>
                                                <div className='row mt-3'>
                                                    <div className='col-12'>
                                                        <span className='title'>Investigations</span>
                                                    </div>
                                                </div>
                                                {
                                                    AncCardData?.anc_result_structured_data?.length > 0
                                                    ?
                                                        AncCardData.anc_result_structured_data.map((service, sIndex) => (
                                                            <div className='row mt-3' key={sIndex}>
                                                                <div className='col-12'>
                                                                    <b>{service.service_name}</b>
                                                                    <table className="table table-bordered mt-2">
                                                                        <thead>
                                                                            <tr>
                                                                                <td width="20%">TEST NAME</td>
                                                                                {(service.dates || []).map((d, di) => (
                                                                                    <td width="12%" key={di}>{moment(d.service_date).format('DD MMM, YYYY')}</td>
                                                                                ))}
                                                                                <td width="20%">REFERENCE INTERVAL</td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                [...new Map((service.dates || []).flatMap(d => d.component_data).map(c => [c.component_name, c])).values()].map((component, ci) => (
                                                                                    <tr key={ci}>
                                                                                        <td>{component.component_name}</td>
                                                                                        {(service.dates || []).map((d, di) => {
                                                                                            const dc = (d.component_data || []).find(x => x.component_name === component.component_name);
                                                                                            return (
                                                                                                <td key={di}>
                                                                                                    {dc ? (<><span dangerouslySetInnerHTML={{ __html: dc.test_value || '' }} /> <span dangerouslySetInnerHTML={{ __html: dc.uom_code || '' }} /></>) : '-'}
                                                                                                </td>
                                                                                            );
                                                                                        })}
                                                                                        <td>{component.ref_range}</td>
                                                                                    </tr>
                                                                                ))
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        ))
                                                    :
                                                    null
                                                }
                                                {
                                                    (AncCardData?.test_procedures_data?.length > 0) || (AncCardData?.investigation_remarks && AncCardData?.investigation_remarks != "")
                                                    ?
                                                        <div className='row mt-3'>
                                                            <div className='col-12'>
                                                                <table className="table table-bordered mt-2">
                                                                    <tbody>
                                                                        {
                                                                            (AncCardData?.test_procedures_data || [])
                                                                                .filter(row => (row.title && row.title != "") || (row.description && row.description != ""))
                                                                                .map((row, rIndex) => (
                                                                                    <tr key={rIndex}>
                                                                                        <td><span dangerouslySetInnerHTML={{ __html: row.title || '-' }} /></td>
                                                                                        <td><span dangerouslySetInnerHTML={{ __html: row.description || '-' }} /></td>
                                                                                    </tr>
                                                                                ))
                                                                        }
                                                                        {
                                                                            AncCardData?.investigation_remarks && AncCardData?.investigation_remarks != ""
                                                                            ?
                                                                                <tr>
                                                                                    <td className='col-2 font-weight-bold'>Remarks</td>
                                                                                    <td><pre style={{ fontSize: "15px", border: "none", margin: 0 }}>{AncCardData?.investigation_remarks}</pre></td>
                                                                                </tr>
                                                                            :
                                                                            null
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    :
                                                    null
                                                }
                                            </>
                                        :
                                        null
                                    }

                                    {
                                    	AncCardData?.vaccine_data?.length > 0 
                                    	? 
                                    		<>
		                                        <div className='row mt-3 '>
		                                            <div className='col-12'>
		                                                <span className='title'>Immunoprophylaxis</span>
		                                            </div>
		                                        </div>

		                                        <div className='row mt-3'>
		                                            <div className='col-12'>
		                                                <div className="table-responsive">
		                                                    <table className="table table-bordered custom-plan-header mt-1 mb-0">
		                                                        <thead>
		                                                            <tr>
		                                                                <th style={{ background: "#f4f4f4", color: 'black' }}>VACCINE</th>
		                                                                <th style={{ background: "#f4f4f4", color: 'black' }}>VACCINE NAME</th>
		                                                                <th style={{ background: "#f4f4f4", color: 'black' }}>GIVEN OUTSIDE</th>
		                                                                <th style={{ background: "#f4f4f4", color: 'black' }}>VACCINATION SITE</th>
		                                                                <th style={{ background: "#f4f4f4", color: 'black' }}>GIVEN ON</th>
		                                                                <th style={{ background: "#f4f4f4", color: 'black' }}>BATCH</th>
		                                                                <th style={{ background: "#f4f4f4", color: 'black' }}>EXPIRY DATE</th>
		                                                                <th style={{ background: "#f4f4f4", color: 'black' }}>REMARKS</th>
		                                                            </tr>
		                                                        </thead>
		                                                        <tbody>
		                                                            {AncCardData.vaccine_data.map((obj, vIndex) => (
		                                                                <tr key={vIndex}>
		                                                                    <td>{(obj.name || '') + (obj.dose_number != null ? ' ' + obj.dose_number : '')}</td>
		                                                                    <td>{obj.vac_name || '-'}</td>
		                                                                    <td>{(obj.given_outside == 1 || obj.given_outside === 'on') ? 'Yes' : 'No'}</td>
		                                                                    <td>
		                                                                        {obj.vac_site == "1" ? "Right /Left Antero-lateral thigh Muscle"
		                                                                            : obj.vac_site == "2" ? "Right /Left Deltoid Muscle"
		                                                                            : obj.vac_site == "3" ? "Right /Left Triceps Muscle"
		                                                                            : obj.vac_site == "4" ? "Right /Left Intradermal"
		                                                                            : obj.vac_site == "5" ? "Right /Left Subcutaneous"
		                                                                            : obj.vac_site == "6" ? "Oral"
		                                                                            : obj.vac_site == "7" ? "Intradermal"
		                                                                            : obj.vac_site == "8" ? "Right Thigh"
		                                                                            : obj.vac_site == "9" ? "Left Thigh"
		                                                                            : obj.vac_site == "10" ? "Left Upper Arm"
		                                                                            : obj.vac_site == "11" ? "Left Deltoid"
		                                                                            : ""}
		                                                                    </td>
		                                                                    <td>{obj.vaccine_date ? moment(obj.vaccine_date).format("DD/MM/YYYY") : null}</td>
		                                                                    <td>{obj.batch}</td>
		                                                                    <td>{obj.expiry_date ? moment(obj.expiry_date).format("DD/MM/YYYY") : null}</td>
		                                                                    <td>{obj.remark || obj.remarks}</td>
		                                                                </tr>
		                                                            ))}
		                                                        </tbody>
		                                                    </table>
		                                                </div>
		                                            </div>
		                                        </div>
                                    		</> 
                                		: 
                                		null
                                	}

                                    {
                                    	AncCardData?.immuno_remarks
                                    	?
	                                        <div className='row mt-3'>
	                                            <div className='col-12'>
	                                                <span className='title'>Immunoprophylaxis Remarks</span>
	                                                <b><pre style={{ fontSize: "15px", border: "none" }}> {AncCardData?.immuno_remarks}</pre></b>
	                                            </div>
	                                        </div>
                                        : 
                                        null
                                    }

                                	{
                                		(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != null) || (AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != null)
                                		?
	                                		<>
			                                	<div className='row mt-3'>
			                                        {
			                                        	(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != null) 
			                                        	?
				                                            <div className='col-6' >
				                                                <span style={{ color: "#FF0000" }}>Risk Factors</span>
				                                            </div>
			                                            : 
			                                            null
			                                        }
			                                        {
			                                        	(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != null) 
			                                        	?
			                                            <div className='col-6'>
			                                                <span style={{ color: "#FF0000" }}>Risk Factors Management Remarks</span>
			                                            </div>
			                                            : 
			                                            null
			                                        }
			                                    </div>
			                                    <div className='row '>
			                                    	{
			                                        	(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != null) 
			                                        	?
			                                        		<>
					                                        <div className='col-6'>
					                                            <span><pre style={{ fontSize: "15px", border: "none" }}>{AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name}</pre></span>
					                                        </div>
					                                        </>
					                                    :
					                                    null
					                                }

					                                {
			                                        	(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != null) 
			                                        	?
			                                        		<>
					                                        <div className='col-6'>
					                                            <span><pre style={{ fontSize: "15px", border: "none" }}>{AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks.replace(/\n/g, '<br>')}</pre></span>
					                                        </div>
					                                        </>
					                                    :
					                                    null
					                                }
			                                    </div>
		                                    </>
		                                :
		                                null
	                                }

                                    <div className='row mt-3 '>
                                        <div className='col-12'>
                                            <span className='title'>Delivery Details</span>
                                        </div>
                                    </div>

                                    <div className='row mt-3'>
                                    	<div className='col-4'>
                                            <span>Pregnancy Year:</span>
                                            <b> {AncCardData?.pregnancy_year}</b>
                                        </div>
                                        <div className='col-4'>
                                            <span>Mode Of Conception:</span>
                                            <b> {AncCardData?.delivery_mode === "1" ? "Natural" : AncCardData?.delivery_mode === "2" ? "IVF" : AncCardData?.delivery_mode === "3" ? "IUI" : ''}</b>
                                        </div>
                                        <div className='col-4'>
                                            <span>Pregnancy Type:</span>
                                            <b> {AncCardData?.pregnancy_type == "1" ? "Single" :
                                                AncCardData?.pregnancy_type == "2" ? "Multiple" :
                                                    AncCardData?.pregnancy_type == "3" ? "Ectopic" : ''}</b>
                                        </div>
                                    </div>
                                    {
                                        /* Delivery Type, Delivery Place and Outcome are common to the whole delivery
                                           (same for every fetus), so show them once here after Pregnancy Type instead
                                           of repeating them in each row of the Pregnancy Details table. Values are read
                                           from the first fetus row (identical across rows). */
                                    }
                                    {
                                        AncCardData?.multiple_pregnancies && AncCardData.multiple_pregnancies.length > 0
                                        ?
                                            <div className='row mt-3'>
                                                <div className='col-4'>
                                                    <span>Delivery Type:</span>
                                                    <b> {DELIVERY_OPTIONS?.filter(x => x.val == AncCardData.multiple_pregnancies[0].delivery_type)?.[0]?.label}
                                                        {AncCardData.multiple_pregnancies[0].delivery_type == '2' && (AncCardData.multiple_pregnancies[0].caesarean_section_type || AncCardData?.caesarean_section_type)
                                                            ? ' (' + this.getCaesareanLabel(AncCardData.multiple_pregnancies[0].caesarean_section_type || AncCardData?.caesarean_section_type) + ')'
                                                            : ''}</b>
                                                </div>
                                                <div className='col-4'>
                                                    <span>Delivery Place:</span>
                                                    <b> {PLACE_OF_DELIVERY_OPTIONS?.filter(x => x.val == AncCardData.multiple_pregnancies[0].delivery_place)?.[0]?.label}</b>
                                                </div>
                                                <div className='col-4'>
                                                    <span>Outcome:</span>
                                                    <b> {OUTCOME_OPTIONS?.filter(x => x.val == AncCardData.multiple_pregnancies[0].delivery_outcome)?.[0]?.label}</b>
                                                </div>
                                            </div>
                                        :
                                        null
                                    }

                                    {
                                    	AncCardData?.multiple_pregnancies && AncCardData.multiple_pregnancies.length > 0 
                                    	?
	                                        <div className='row mt-3'>
	                                        	<div className='col-12'>
                                                    <span className='title'>Pregnancy Details</span>
                                                </div>
	                                            <div className='col-12'>
	                                                <table className="table table-bordered mt-3" >
	                                                    <thead>
	                                                        <tr>
	                                                            <td width="5%">FETUS NO.</td>
	                                                            <td width="5%">Gender</td>
	                                                            <td width="10%">Birth Date & Time</td>
	                                                            <td width="10%">Birth Weight (kg)</td>
	                                                            <td width="10%">Birth Height (cm)</td>
	                                                            <td width="10%">Birth Head CC (cm)</td>
	                                                            <td width="10%">Congenital Abnormality</td>
	                                                            <td width="10%">Congenital Abnormality Remarks</td>
	                                                        </tr>
	                                                    </thead>
	                                                    <tbody>
	                                                        {this.showMultiplePregnancyData(AncCardData?.multiple_pregnancies)}
	                                                    </tbody>
	                                                </table>
	                                            </div>
	                                        </div>
                                        : 
                                        null
                                    }
                                    <div className='row mt-3'>
                                        {
                                        	AncCardData?.delivery_indication_for_c_section != null && AncCardData?.delivery_indication_for_c_section != "" 
                                        	?
	                                            <div className='col-6'>
	                                                <span>Indication for C-Section:</span>
	                                                <b> {AncCardData?.delivery_indication_for_c_section}</b>
	                                            </div>
                                            : 
                                            null
                                        }
                                        {
                                        	AncCardData?.delivery_details != null && AncCardData?.delivery_details != "" 
                                        	?
	                                            <div className='col-6'>
	                                                <span>Details:</span>
	                                                <b> {AncCardData?.delivery_details}</b>
	                                            </div>
                                            : 
                                            null
                                        }
                                    </div>
                                    <div className='row mt-3 '>
                                        <div className='col-12 text-center'>
											<button onClick={() => this.printAncDetails()} type="button" className="btn btn-primary px-5 mr-3">Print {this.state.isPrintLoader ? LOADER : null}</button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    title="Anc Details"
                    visible={this.state.showRxModal}
                    footer={false}
                    width={850}
                    onCancel={() => { this.setState({ showRxModal: false, rxPdfPath: null }) }}
                    style={{ top: 20 }}
                >
                    <div className="row">
                        <div className="col-12 my-3 text-center">
                            <iframe src={this.state.rxPdfPath} frameBorder="0" scrolling="no" style={{ overflow: 'hidden' }} width="100%" height="700"></iframe>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}


